var $55b0693b2cf3fe91$exports = {};
$55b0693b2cf3fe91$exports = {
    "breadcrumbs": `\u{422}\u{440}\u{43E}\u{445}\u{438} \u{445}\u{43B}\u{44F}\u{431}`
};


export {$55b0693b2cf3fe91$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
